// import axios from "axios";
import request from "../utils/http";


export function LoginParam(data) {
    return request.post(
        // 'http://localhost:18083/login',data
        '/login',
        data,
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        }
    )
}

export function logout() {
  return request.get(
    '/logout',
  )

}


